import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import messages from 'containers/LawyerFeeNote/messages';
import { translate } from 'containers/services/translate';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardTitle from 'containers/common/Card/CardTitle';
import { connect } from 'react-redux';
import { Tab, Tabs } from '@material-ui/core';
import { createStructuredSelector } from 'reselect';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import {
  requestManagerFeeNotes,
  requestOpeningManagerFeeNotes,
  makeDecisionFeeNote,
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByPolicyNumber,
  requestManagerAllFeeNotes,
  requestCreateCostsSagis,
} from 'containers/ManagerFeeNote/actions';
import {
  requestGetPreOpenManagerFeeNote,
  requestSearchPreOpenManagerFeeNote,
} from 'containers/PreOpenManagerFeeNote/actions';
import { setNotificationFeeNote } from 'containers/AppContainer/actions';
import { makeSelectNotifFeeNoteManager } from 'containers/AppContainer/selectors';
import SearchBarFeeNote, { SearchQuery } from 'components/SearchBarFeeNote';
import {
  requestCreateFeeNote,
  requestFeeNoteCosts,
  requestUpdateFeeNoteAmount,
  requestUpdateFeeNoteStatus,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
  requestUpdateFirmReferenceManager,
} from 'containers/LawyerFeeNote/actions';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
} from 'containers/UploadDocuments/actions';
import { FeeNoteContainer } from 'containers/LawyerFeeNote/styled-components';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import FeeNoteTable from 'containers/LawyerFeeNote/FeeNoteTable';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import {
  makeSelectCountFeeNotes,
  makeSelectFeeNotes,
  makeSelectAllFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { ALL_STATUS } from 'containers/LawyerFeeNote/constants';
import { Listings } from 'containers/AppContainer/typings';
import { makeSelectListings } from 'containers/AppContainer/selectors';

export interface PreOpenManagerFeeNoteProps {
  location: { pathname: string };
  intl: IntlShape;
  feeNotes: FeeNote[];
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  documentId: string;
  setDocumentId: Function;
  requestManagerFeeNotes: Function;
  requestOpeningManagerFeeNotes: Function;
  requestCreateFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  keyclokToken: string | null;
  makeDecisionFeeNote: Function;
  requestFeeNotesByClaimNumb: Function;
  listings: Listings;
  requestAllFeeNotes: Function;
  allFeeNote: FeeNote[];
  feeNotesCount: number;
  requestFeeNotesByPolicyNumber: Function;
  requestUpdateFeeNoteAmount: Function;
  requestUpdateFeeNoteStatus: Function;
  notifFeeNote: any;
  requestManagerAllFeeNotes: Function;
  setNotificationFeeNote: Function;
  loaders: {};
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestCreateCostsSagis: Function;
  requestGetPreOpenManagerFeeNote: Function;
  requestSearchPreOpenManagerFeeNote: Function;
  requestUpdateFirmReferenceManager: Function;
}

export const PreOpenManagerFeeNote: React.FC<PreOpenManagerFeeNoteProps> = (
  props,
): JSX.Element => {
  const [searchQuery, setSearchQuery] = React.useState<SearchQuery>({
    claimNumber: null,
    policyNumber: null,
  });
  const [tab, setTab] = React.useState(0);
  const [page, setPage] = React.useState<number>(0);
  /* istanbul ignore next */
  const handleChange = (event: React.ChangeEvent<{}>, newTabIndex: number) => {
    setTab(newTabIndex);
    setPage(0);
  };
  /* istanbul ignore next */
  const handlerSearch = () => {
    if (searchQuery.claimNumber)
      props.requestSearchPreOpenManagerFeeNote(searchQuery);
    if (searchQuery.policyNumber)
      return props.requestSearchPreOpenManagerFeeNote(searchQuery);
  };
  /* istanbul ignore next */
  const handlerRefresh = () => {
    setSearchQuery({
      claimNumber: null,
      policyNumber: null,
    });
    props.requestGetPreOpenManagerFeeNote(ALL_STATUS[tab], 0, 25);
  };
  return (
    <FeeNoteContainer>
      <Card>
        <Tabs
          value={tab}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          className="tab-container"
        >
          <Tab
            label={translate(messages.pendingTabTitle, props)}
            data-testid="tab-1"
          />
          <Tab label={translate(messages.validatedTabTitle, props)} />
          <Tab label={translate(messages.rejectedTabTitle, props)} />
        </Tabs>
        <CardContent>
          <div className="header">
            <Grid container direction="row">
              <Grid item xs={8}>
                <CardTitle
                  count={props.feeNotesCount}
                  message={translate({ ...messages.feeNoteCardTitle }, props)}
                />
              </Grid>
              <Grid item xs={4}>
                <SearchBarFeeNote
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  handleSearch={handlerSearch}
                  handlerRefresh={handlerRefresh}
                />
              </Grid>
            </Grid>
          </div>
          <FeeNoteTable
            feeNotes={props.feeNotes}
            feeNotesCount={props.feeNotesCount || 0}
            requestAllFeeNotes={props.requestGetPreOpenManagerFeeNote}
            allFeeNotes={props.allFeeNote}
            requestFeeNotes={props.requestGetPreOpenManagerFeeNote}
            requestCreateFeeNote={props.requestCreateFeeNote}
            requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
            keyclokToken={props.keyclokToken}
            resetUploadDocumentStore={props.resetUploadDocumentStore}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            setDocumentId={props.setDocumentId}
            setNotificationFeeNote={props.setNotificationFeeNote}
            documentId={props.documentId}
            isManager={true}
            status={ALL_STATUS[tab]}
            selectedStatus={ALL_STATUS[tab]}
            showButtonAdd={true}
            makeDecisionFeeNote={props.makeDecisionFeeNote}
            listings={props.listings}
            viewByClaim={false}
            setPage={setPage}
            page={page}
            requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
            requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
            notifFeeNote={props.notifFeeNote}
            requestManagerAllFeeNotes={props.requestManagerAllFeeNotes}
            loaders={props.loaders}
            requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
            requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
            requestCreateCostsSagis={props.requestCreateCostsSagis}
            requestUpdateFirmReferenceManager={
              props.requestUpdateFirmReferenceManager
            }
          />
        </CardContent>
      </Card>
    </FeeNoteContainer>
  );
};

const mapDispatchToProps = {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
  requestOpeningManagerFeeNotes,
  requestManagerFeeNotes,
  requestCreateFeeNote,
  requestFeeNoteCosts,
  makeDecisionFeeNote,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
  requestFeeNotesByPolicyNumber,
  requestUpdateFeeNoteAmount,
  requestUpdateFeeNoteStatus,
  requestManagerAllFeeNotes,
  setNotificationFeeNote,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
  requestCreateCostsSagis,
  requestGetPreOpenManagerFeeNote,
  requestSearchPreOpenManagerFeeNote,
  requestUpdateFirmReferenceManager,
};

const mapStateToProps = createStructuredSelector({
  uploadedDocument: makeSelectDocument(),
  documentId: makeSelectDocumentId(),
  feeNotes: makeSelectFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  keyclokToken: makeSelectKeycloakToken(),
  listings: makeSelectListings(),
  allFeeNote: makeSelectAllFeeNotes(),
  notifFeeNote: makeSelectNotifFeeNoteManager(),
  loaders: selectedLoader,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PreOpenManagerFeeNote));
